import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { Provider } from 'react-redux';
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { SnackbarProvider } from "notistack";
import store from "./store/index.tsx";
import ErrorBoundary from "@/utils/ErrorBoundary.tsx";
import FallbackPage from "@/pages/Fallback.tsx";
import {initializeSentry} from "@/utils/sentry.ts";
import {isBitramp} from "./utils/utils.tsx";

const queryClient = new QueryClient();

const onRetry = () => {
    queryClient.resetQueries().finally(() => {
      window.location.reload();
    })
}

if (isBitramp()) {
  document.title = "Bitramp";

  const favicon = document.querySelector("link[rel='icon']");
  if (favicon) {
    favicon.setAttribute("href", "/src/assets/LogoBitramp.svg");
  }
}


const IS_PROD = import.meta.env.VITE_IS_PRODUCTION
initializeSentry(IS_PROD)

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<FallbackPage onRetry={onRetry} />}>
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider>
        <ReactQueryDevtools initialIsOpen={false} />
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </SnackbarProvider>
    </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
